import styled from "styled-components";
import InputWithLabel from "shared/components/InputWithLabel";
import { hw } from "features/homework/homeworkUi";

interface NormalInputsProps{
    branchInputs:{
        name:string,
        tel:string,
        address:string,
        address_detail:string,
        business_num:string,
        owner_name:string,
        owner_tel:string,
        id:string,
        pw:string,
        pw_re:string
    },
    onBranchChange:(event: React.ChangeEvent<HTMLInputElement>) => void
}

const NormalInputs = ({ branchInputs, onBranchChange}:NormalInputsProps) => {
    return(
        <Container>
            <Title>추가 정보</Title>
            <Inputs>
                <InputWithLabel label="원장 전화번호" name="owner_tel" value={branchInputs.owner_tel} onChange={onBranchChange} placeholder="원장 전화번호를 입력해주세요"/>
                <InputWithLabel label="학원 전화번호" name="tel" value={branchInputs.tel} onChange={onBranchChange} placeholder="학원 전화번호를 입력해주세요"/>
                <InputWithLabel label="주소" name="address" value={branchInputs.address} onChange={onBranchChange} placeholder="주소를 입력해주세요"/>
                <InputWithLabel label="상세 주소" name="address_detail" value={branchInputs.address_detail} onChange={onBranchChange} placeholder="상세 주소를 입력해주세요"/>
            </Inputs>
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    background: ${hw.bg};
    padding: 20px 22px;
    border-radius: 14px;
    border: 1px solid ${hw.border};
`

const Title = styled.h2`
    margin: 0;
    color: ${hw.text};
    font-size: 16px;
    font-weight: 700;
    letter-spacing: -0.02em;
`

const Inputs = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px 20px;

    @media (max-width: 800px) {
        grid-template-columns: 1fr;
    }
`

export default NormalInputs;
